// extracted by mini-css-extract-plugin
module.exports = {"right":"_1z6iSB"};